<template>
  <div class="header-box">
    <div class="float-right">
      <ul>
        <!-- <li>
					<router-link to="/search"><img src="../assets/images/ftr_1.png"></router-link>
				</li> -->
        <!-- <li><a href=""><img src="../assets/images/ftr_2.png"></a></li> -->
        <li>
          <router-link to="/meCollection"
            ><img src="../assets/images/ftr_3.png"
          /></router-link>
        </li>
        <li>
          <router-link to="/meCart"
            ><img src="../assets/images/ftr_4.png"
          /></router-link>
        </li>
        <li class="goTop">
          <a href="javascript:;"><img src="../assets/images/ftr_5.png"/></a>
        </li>
      </ul>
    </div>
    <div class="eject-box login-eject" :key="timerEject">
      <div class="center-center">
        <div class="eject-bg" onclick="$('.eject-box').fadeOut();"></div>
        <div class="login-box">
          <div class="box-info1 w-100 between-center">
            <span>账号登录</span><i onclick="$('.login-eject').fadeOut();"></i>
          </div>
          <div class="box-info2 w-100">
            <input
              type="text"
              name=""
              v-model="phone"
              maxlength="11"
              placeholder="手机号"
            />
            <input
              type="password"
              name=""
              v-model="password"
              @keyup.enter="login"
              placeholder="密码"
            />
          </div>
          <input type="button" class="btns" value="登录" @click="login" />
          <div class="box-info3 w-100 between-center">
            <span @click="navTo('resetPassword')"><i>忘记密码</i></span>
            <span @click="navTo('register')"><i>注册</i></span>
          </div>

          <div class="third-login" v-if="false">
            <span class="third-line">第三方登录</span>
            <div class="third-list">
              <span @click="undeveloped" class="qq-login">
                <img src="../assets//images/qq-login.png" alt="" />
              </span>
              <span @click="undeveloped" class="weixin-login">
                <img src="../assets/images/weixin-login.png" alt="" />
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="head-box w-100">
      <div class="top-box w-100">
        <div class="w-1500 between-center">
          <div class="pull-left">
            <div class="box1 f-l">
              欢迎来到<router-link to="/">汇利兴</router-link>
            </div>
            <div class="box2 f-l">
              <a
                href="javascript:;"
                onclick="$('.login-eject').fadeIn();"
                v-if="!userInfo.nickname"
                >请登录</a
              >
              <router-link to="/register" v-if="!token">免费注册</router-link>
              <a href="" v-if="userInfo.nickname"
                >您好！{{ userInfo.nickname }}</a
              >
            </div>
            <div class="box2 f-l" @click="quit" v-if="token">
              <a href="javascript:;">退出</a>
            </div>
          </div>
          <div class="pull-right between-center">
            <div class="box1 f-l">
              <span>我是采购</span>
              <!-- <ul>
								<li><a href="">二级菜单</a></li>
								<li><a href="">二级菜单</a></li>
								<li><a href="">二级菜单</a></li>
							</ul> -->
              <ul>
                <li><a @click="undeveloped">我是设计师</a></li>
              </ul>
            </div>
            <div class="box2 f-l">
              <!-- <router-link to="/meMsg"
                ><img src="../assets/images/icon_1.png" />消息</router-link
              > -->
              <a href="javascript:;" @click="token ? navTo('meMsg') : goLogin()"
                ><img src="../assets/images/icon_1.png" />消息</a
              >
              <a href="javascript:;" @click="token ? navTo('me') : goLogin()"
                ><img src="../assets/images/icon_2.png" />我的订单</a
              >
              <a
                href="javascript:;"
                @click="token ? navTo('meInquiry') : goLogin()"
                ><img src="../assets/images/icon_3.png" />我的询价</a
              >
              <router-link to="/about"
                ><img src="../assets/images/icon_4.png" />关于我们</router-link
              >
              <router-link to="/userServers">
                <img src="../assets/images/icon_1.png" />
                <!-- <img src="../assets/images/icon_5.png" /> -->
                意见反馈</router-link
              >
            </div>
          </div>
        </div>
      </div>

      <!-- 此样式废弃 -->
      <div v-if="false" class="lower-box w-100">
        <div class="w-1500 between-center">
          <router-link to="/"
            ><img src="../assets/images/logo2.png" class="pull-left"
          /></router-link>
          <!-- <a href=""><img src="../assets/images/logo.png" class="pull-left"></a> -->
          <div class="pull-right between-center">
            <div class="head-search" style="display: flex;">
              <div class="text" style="flex: 1;display: flex;background-color: #fff;">
                <input
                  type="text"
                  style="flex: 1;border: none;"
                  name=""
                  clearable
                  v-model="keyword"
                  @keyup.enter="search"
                  placeholder="搜索名称/型号"
                />
                <div v-show="keyword" style="display: flex;align-items: center;justify-content: center;height: 100%;" @click="keyword = ''">
                  <i class="el-icon-circle-close"></i>
                </div>
              </div>
              
              <input type="button" class="btns" value="" @click="search" />
              <!-- <div class="hot-search">
                热门搜索：

                <span>3D打印机</span>
                <span>铝型材</span>
                <span>直线导轨</span>
                <span>输送带</span>
              </div> -->
            </div>
            <router-link
              to="/quickQuotation"
              class="head-kuaisu between-center"
            >
              <span><i v-if="userInfo.id"></i></span>
              <p>快速报价</p>
            </router-link>
            <router-link to="/meCart" class="head-shopcat between-center">
              <span
                ><i v-if="userInfo.id">{{ total }}</i></span
              >
              <p>购物车</p>
            </router-link>
          </div>
        </div>
      </div>

      <div class="lower-box w-100" style="position: relative;">
        <img
          src="../assets/images/head_search.png"
          style="height: 100%;position: absolute;left: 0;top: 0;z-index: 0;width: 100%;"
        />
        <div class="w-1500 between-center" style="gap: 1rem;position: relative;z-index: 1;">
          <router-link to="/"
            ><img src="../assets/images/logo_text.png" class="pull-left" style="height: 3.25rem;"
          /></router-link>
          <!-- <a href=""><img src="../assets/images/logo.png" class="pull-left"></a> -->
          <div class="pull-right between-center" style="position: relative;flex: 1;">
            <div style="position: absolute;right: calc(-1.625rem - 3.8125rem);">
              <img src="../assets/images/hxzz_gzh.png" style="width: 3.8125rem;" />
            </div>

            <div class="head-search" style="display: flex;height: 2.125rem;border-radius: 2px;overflow: hidden;">
              <div class="" style="flex: 1;display: flex;background-color: #fff;height: 100%;width: 21.5625rem;align-items: center;padding: 0 0.5rem;gap: 0.4rem;">
                <img src="../assets/images/search1.png" class="pull-left" style="height: 1rem;" />
                <input
                  type="text"
                  style="flex: 1;border: none;"
                  name=""
                  clearable
                  v-model="keyword"
                  @keyup.enter="search"
                  placeholder="搜索名称/型号"
                />
                <div v-if="keyword" style="display: flex;align-items: center;justify-content: center;height: 100%;" @click="keyword = ''">
                  <i class="el-icon-circle-close"></i>
                </div>
              </div>
              
              <div style="cursor: pointer;height: 100%;width: 3.5625rem;background-color: #38a3fd;color: #fff;display: flex;align-items: center;justify-content: center;font-size: 0.875rem;" @click="search">
                搜索
              </div>
              <!-- <input type="button" class="btns" value="" @click="search" /> -->
              <!-- <div class="hot-search">
                热门搜索：

                <span>3D打印机</span>
                <span>铝型材</span>
                <span>直线导轨</span>
                <span>输送带</span>
              </div> -->
            </div>
            <router-link
              to="/quickQuotation"
              class=""
              style="display: flex;align-items: center;justify-content: center;gap: 0.25rem;height: 2.125rem;border-radius: 2px;width: 5.8125rem;background: linear-gradient(to bottom, #fdb813 0%, #fd9e13 100%);padding: 0 0.4rem;"
            >
              <img v-if="userInfo.id" src="../assets/images/lightning1.png" class="pull-left" style="height: 1rem;display: inline-block;margin-top: 0.1rem;" />
              <p style="color: #fff;font-size: 1rem;line-height: 1rem;">快速报价</p>
            </router-link>
            <router-link
              to="/meCart"
              class=""
              style="display: flex;align-items: center;justify-content: center;gap: 0.25rem;height: 2.125rem;border-radius: 2px;min-width: 5.8125rem;background: linear-gradient(to bottom, #dee8f8 0%, #dee8f8 100%);padding: 0 0.4rem;"
            >
              <img v-if="userInfo.id" src="../assets/images/cart1.png" class="pull-left" style="height: 1rem;display: inline-block;" />
              <p style="color: red;font-size: 1rem;line-height: 1rem;">购物车</p>
              <span style="color: #fff;height: 1rem;min-width: 1rem;display: inline-flex;align-items: center;justify-content: center;background-color: red;border-radius: 0.5rem;font-size: 0.75rem;">
                {{ total }}
              </span>
            </router-link>
          </div>
        </div>
      </div>

    </div>

    <el-dialog title="提示" :visible.sync="addressShow" width="50%" @close="addrListClose">
      <div class="table fff">
        <el-col :md="24" :sm="24" :xs="24" class="grid-cell el-col-btn">
          <el-button type="primary" icon="el-icon-plus" @click="addEditBtn(1)">新增</el-button>
        </el-col>
        <el-table
          ref="refTable"
          stripe
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
        >
          <!-- <el-table-column type="selection" :selectable="(row, index) => row.status === 1" /> -->
          <el-table-column label="序号" type="index" width="55" />
          <el-table-column label="收件人" prop="receiverName" show-overflow-tooltip />
          <el-table-column label="电话号码" prop="receiverPhone" show-overflow-tooltip />
          <el-table-column label="地址" prop="status" show-overflow-tooltip>
            <template #default="scope">
              {{ scope.row.province + scope.row.city + scope.row.county + scope.row.detailAddress }}
            </template>
          </el-table-column>
          <el-table-column label="是否默认地址" prop="status" show-overflow-tooltip>
            <template #default="scope">
              <el-tag v-if="scope.row.defaultTag === 1" type="success">是</el-tag>
              <el-tag v-else type="info">否</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="200" fixed="right" align="center">
            <template #default="scope">
              <div class="handle center-center-center">
                <el-button type="text" icon="el-icon-thumb" @click="selectBtn(scope.row)">选择</el-button>
                <el-button type="text" icon="el-icon-edit" @click="addEditBtn(2, scope.row)">修改</el-button>
                <el-button type="text" style="color:red" icon="el-icon-delete" @click="scopeDel(scope.row)">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div v-if="false" class="pagination pd20" style="display: flex; justify-content: flex-end;">
          <el-pagination
            @current-change="init"
            :current-page="queryParams.pageIndex"
            :page-sizes="[10, 20, 50, 100, 200, 500]"
            :page-size="queryParams.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableTotal"
          />
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addrListClose">关 闭</el-button>
      </span>
    </el-dialog>

    <el-dialog title="提示" :visible.sync="addEditDialog" width="50%">
      <el-form :key="timer" ref="addEditForm" :model="addEditForm" :rules="addEditRules" label-position="right" label-width="130px" @submit.native.prevent>
        <el-row>
          <el-col :md="24" :sm="24" :xs="24" class="grid-cell">
            <el-form-item label="收货人" prop="receiverName">
              <el-input v-model="addEditForm.receiverName" type="text" placeholder="请填写收货人姓名" clearable />
            </el-form-item>
          </el-col>
          <el-col :md="24" :sm="24" :xs="24" class="grid-cell">
            <el-form-item label="手机号码" prop="receiverPhone">
              <el-input v-model="addEditForm.receiverPhone" type="text" placeholder="请填写收货人手机号码" clearable />
            </el-form-item>
          </el-col>
          <el-col :md="24" :sm="24" :xs="24" class="grid-cell">
            <el-form-item label="地址" prop="addr">
              <el-cascader v-model="addEditForm.addr" :options="regionData" :props="{ expandTrigger: 'hover' }" placeholder="请选择地址" style="width: 100%;" @change="addrChange" />
            </el-form-item>
          </el-col>
          <el-col :md="24" :sm="24" :xs="24" class="grid-cell">
            <el-form-item label="详细地址" prop="detailAddress">
              <el-input v-model="addEditForm.detailAddress" type="text" placeholder="请填写街道、楼牌号" clearable />
            </el-form-item>
          </el-col>
          <el-col :md="24" :sm="24" :xs="24" class="grid-cell">
            <el-form-item label="是否默认地址" prop="defaultTag">
              <el-radio-group v-model="addEditForm.defaultTag">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="9">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addEditDialog = false">关 闭</el-button>
        <el-button type="primary" @click="addEditConfirm">提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { message } from '@/common/common.js';
import { getLogin, goodsCart, getUserAddressInfo, postUserAddressInfo, putUserAddressInfo, delUserAddressInfo } from '@/common/http.js';
// 状态机控制loading
import { mapState } from 'vuex';
import { logout } from '../common/http';
import { regionData, CodeToText, TextToCode } from 'element-china-area-data'
export default {
  computed: {
    ...mapState(['refreshCart']),
    token() {
      return this.$store.state.token
    },
    userInfo() {
      return this.$store.state.userInfo
    }
  },
  data() {
    return {
      regionData,
      // userInfo: {},
      phone: '',
      password: '',
      // token: '',
      total: 0,
      keyword: '',
      timerEject: 0,

      addressShow: false,
      formData: {
        
      },
      tableTotal: 10,
      queryParams: {
        pageIndex: 1,
        pageSize: 9999
      },
      tableData: [],
      tableLoading: true,
      selectTable: [],
      addEditDialog: false,
      addEditTitle: '',
      addEditForm: {
        uid: '',
        receiverName: '',
        receiverPhone: '',
        addr: [],
        province: '',
        city: '',
        county: '',
        detailAddress: '',
        defaultTag: 1
      },
      addEditRules: {
        receiverName: [{ required: true, message: '请填写收货人姓名' }],
        receiverPhone: [{ required: true, message: '请填写收货人手机号码' }],
        addr: [{ required: true, message: '请选择所在地区' }],
        province: [{ required: true, message: '请选择所在地区' }],
        city: [{ required: true, message: '请选择所在地区' }],
        county: [{ required: true, message: '请选择所在地区' }],
        detailAddress: [{ required: true, message: '请填写街道、楼牌号' }],
        defaultTag: [{ required: true, message: '请选择是否默认地址' }]
      },
      addEditType: 1,
      timer: 0
    };
  },
  watch: {
    '$store.state.addressShow': {
      handler(newVal, oldVal) {
        this.addressShow = newVal
        if (newVal) {
          this.getAddrList()
        }
      },
      immediate: true
    },
    refreshCart: {
      handler(newVal, oldVal) {
        if (newVal == true) {
          this.init();
          this.$store.commit('refreshCart', false);
        }
      },
      deep: true,
      immediate: true
    },
    // '$route.fullPath': {
    //   handler(newVal, oldVal) {
    //     this.init()
    //   },
    //   immediate: true
    // }
  },
  activated() {

  },
  mounted() {
    console.log('regionData---', regionData, this.$route.fullPath)
    // this.token = localStorage.getItem('token');
    // if (this.token) {
    //   if (localStorage.getItem('userInfo')) {
    //     this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
    //     this.init();
    //   }
    // }

    // this.getAddrList()

    // setTimeout(() => {
    //   console.log('sendMessage', window)
    //   window.top.postMessage({ type: 'getToken' }, '*')

    //   function sendModelToApp(data) {
    //     // 准备数据
    //     const msg = JSON.stringify(data);
    //     const url = 'shindi-model://' + encodeURIComponent(msg);
    //     // 使用 iframe 触发跳转（这是 iOS 和安卓原生拦截最通用的方式）
    //     const iframe = document.createElement('iframe');
    //     iframe.style.display = 'none';
    //     iframe.src = url;
    //     document.documentElement.appendChild(iframe);
    //     // 销毁 iframe
    //     setTimeout(function() {
    //         if (iframe.parentNode) iframe.parentNode.removeChild(iframe);
    //     }, 500);
    //   }
    //   sendModelToApp({ type: 'getToken' })
    // }, 500)
  },
  methods: {
    selectBtn(e) {
      const that = this
      const index = that.tableData.findIndex((item) => item.id === e.id)
      if (index !== -1) {
        that.tableData.forEach((it, id) => {
          that.tableData[id].select = false
        })
        that.tableData[index].select = true
        that.$store.commit('SET_ADDRESS', that.tableData)
        this.$store.commit('SET_ADDR_SHOW', false)
      }
    },
    addrChange(e) {
      const that = this
    },
    addEditBtn(type, e) {
      const that = this
      that.addEditType = type
      if (type === 1) {
        Object.keys(that.addEditForm).forEach(item => {
          if (item === 'addr') {
            that.addEditForm[item] = []
            return
          }
          that.addEditForm[item] = ''
        })
        that.addEditTitle = '添加地址'
      } else {
        that.addEditTitle = '修改地址'
        Object.keys(that.addEditForm).forEach(item => {
          if (e[item]) {
            that.addEditForm[item] = e[item]
          }
        })

        const isMatch = (fullName, shortName) => {
            return fullName.includes(shortName) || shortName.includes(fullName)
        }
        if (that.addEditForm.province) {
          const provinceData = that.regionData.find((item) => isMatch(item.label, that.addEditForm.province))
          if (provinceData) {
            that.addEditForm.addr[0] = provinceData.value
            if (provinceData.children && provinceData.children.length > 0) {
              const cityData = provinceData.children.find((item) => isMatch(item.label, that.addEditForm.city))
              if (cityData) {
                that.addEditForm.addr[1] = cityData.value
                if (cityData.children && cityData.children.length > 0) {
                  const countyData = cityData.children.find((item) => isMatch(item.label, that.addEditForm.county))
                  that.addEditForm.addr[2] = countyData.value
                }
              }
            }
          }
        }
      }
      that.addEditDialog = true
      that.timer = new Date().getTime()
      console.log('addEditForm', that.addEditForm)
    },
    addEditConfirm() {
      const that = this
      // return
      that.addEditForm.province = that.addEditForm.addr[0] ? CodeToText[that.addEditForm.addr[0]] : ''
      that.addEditForm.city = that.addEditForm.addr[1] ? CodeToText[that.addEditForm.addr[1]] : ''
      that.addEditForm.county = that.addEditForm.addr[2] ? CodeToText[that.addEditForm.addr[2]] : ''
      console.log('that.addEditForm', that.addEditForm)
      that.$refs['addEditForm'].validate(valid => {
        if (!valid) return
        that.$confirm(`确定要提交并保存此地址吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let formData = {
            receiverName: that.addEditForm.receiverName,
            receiverPhone: that.addEditForm.receiverPhone,
            province: that.addEditForm.province,
            city: that.addEditForm.city,
            county: that.addEditForm.county,
            detailAddress: that.addEditForm.detailAddress,
            defaultTag: that.addEditForm.defaultTag
          }
          if (that.addEditType === 1) { // 新增
            postUserAddressInfo(formData).then(res => {
              if (res.result) {
                that.$message({
                  message: res.msg,
                  type: 'success'
                })
                that.$refs['addEditForm'].resetFields()
                that.addEditDialog = false
                that.queryParams.pageIndex = 1
                that.getAddrList()
              } else {
                that.$message.error(res.msg ? res.msg : '请求失败')
              }
            }).catch(() => { })
          } else {
            formData.uid = that.addEditForm.uid
            putUserAddressInfo(formData).then(res => {
              if (res.result) {
                that.$message({
                  message: res.msg,
                  type: 'success'
                })
                that.$refs['addEditForm'].resetFields()
                that.addEditDialog = false
                that.queryParams.pageIndex = 1
                that.getAddrList()
              } else {
                that.$message.error(res.msg ? res.msg : '请求失败')
              }
            }).catch(() => { })
          }
        }).catch(() => { })
      })
    },
    scopeDel(e) {
      const that = this
      that.$confirm(`确定要删除此地址吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delUserAddressInfo({ uid: e.uid }).then(res => {
          if (res.result) {
            that.$message({
              message: res.msg,
              type: 'success'
            })
            that.queryParams.pageIndex = 1
            that.getAddrList()
          } else {
            that.$message.error(res.msg ? res.msg : '请求失败')
          }
        }).catch(() => { })
      }).catch(() => { })
    },
    addrListClose() {
      this.$store.commit('SET_ADDR_SHOW', false)
    },
    getAddrList() {
      const that = this
      getUserAddressInfo({ ...that.queryParams, ...that.formData }).then(res => {
        if (res.result) {
          that.tableData = res.data.rows.map((item) => {
            return {
              ...item,
              select: false
            }
          })
          const isSelect = this.$store.state.addressList.find((item) => item.select)
          if (isSelect) {
            const index = that.tableData.findIndex((item) => item.id === isSelect.id)
            that.tableData[index].select = true
          }
          that.$store.commit('SET_ADDRESS', that.tableData)
          if (that.tableData.length === 0) {
            that.$store.commit('CLEAR_ADDRESS')
          }
          that.tableTotal = res.data.total
          that.tableLoading = false
        } else {
          that.$message.error(res.data.msg ? res.data.msg : '请求失败')
        }
      }).catch(() => {
        that.$store.commit('SET_ADDR_SHOW', false)
      })
    },
    init() {
      let that = this;
      goodsCart({
        type: 1
      }).then(res => {
        if (res.result) {
          that.total = res.data.length

          // let list = [];
          // if (res.data[0] === undefined) {
          //   that.total = 0;
          //   return;
          // }
          // if (res.data.length != 0) {
          //   res.data.map(item => {
          //     list.push(item);
          //   });
          //   that.total = list.length; // 算总数
          // }
        }
      });
    },
    search() {
      if (!this.keyword) {
        message({
          message: '请输入搜索内容！'
        });
        return;
      }
      // message({
      //   type: 'info',
      //   message: '敬请期待！'
      // })

      this.$store.commit('SET_SEARCHVALUE', this.keyword);

      if (this.$route.path == '/search') {
        return;
      }
      this.$router.push({
        name: 'search',
        path: '/search'
        // query: {
        //   keyword: this.keyword
        // }
      });
    },
    login() {
      if (!this.phone) {
        message({
          message: '手机号不能为空！'
        });
        return;
      }
      if (!this.password) {
        message({
          message: '请输入密码！'
        });
        return;
      }
      getLogin({
        password: this.password,
        phone: this.phone
      }).then(res => {
        if (res.result) {
          message({
            message: '登陆成功！',
            type: 'success'
          });
          let obj = {
            password: this.password,
            phone: this.phone
          };
          localStorage.setItem('account', JSON.stringify(obj));
          localStorage.setItem('userInfo', JSON.stringify(res.data.user));
          localStorage.setItem('userExt', JSON.stringify(res.data.userExt));
          localStorage.setItem('token', res.data.token);

          this.$store.commit('SET_USER', res.data.user)
          this.$store.commit('SET_TOKEN', res.data.token)

          this.timerEject = new Date().getTime()

          this.getAddrList()
          this.init()
          this.$store.commit('refreshCart', true)

          setTimeout(() => {
            // window.location.reload();
            // location.reload()
            // this.$router.replace({
            //   path: this.$route.path,
            //   query: {
            //     ...this.$route.query,
            //     _t: Date.now()
            //   }
            // })
          }, 1000);
        } else {
          message({
            message: res.data.msg,
            type: 'error'
          });
        }
      });
    },
    quit() {
      logout()
        .then(res => {
          console.log(res);
          if (res.result) {
            localStorage.clear();
            message({
              message: '退出成功',
              type: 'success'
            });
            setTimeout(() => {
              this.$router.push('/');
              window.location.reload();
            }, 1000);
          }
        })
        .catch(e => {
          message({
            message: '退出成功',
            type: 'success'
          });
          localStorage.clear();
          this.$router.push('/');
          this.$store.commit('CLEAR_USER')
          window.location.reload();
        });
    },
    navTo(url) {
      $('.login-eject').fadeOut();
      this.$router.push({
        path: `/${url}`
      });
    },
    goLogin() {
      $('.login-eject').fadeIn();
    },
    undeveloped() {
      message({
        message: '功能暂未开放',
        type: 'warning'
      });
    },
    meInquiryClick() {
      this.token = localStorage.getItem('token');
      if (this.token) {
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
        this.$router.push({
          path: '/meInquiry'
        });
      } else {
        message({
          message: '请登录过后进行查看',
          type: 'warning'
        });
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/header.vue